import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Grid, Box, Text } from "@theme-ui/components"

const DoubleImages = ({ images }) => {
  // console.log(image)
  return (
    <Box
      pb={[0]}
      sx={{
        backgroundColor: "darkGrey",
      }}
    >
      <Grid columns={["1fr", ".7fr 1fr"]} gap={[4, 5, 6, 7]}>
        {images.map((image, index) => (
          <Box
            sx={{
              ".gatsby-image-wrapper": {
                width: "100%",
                height: "100%",
                borderRadius: "0 75px",
                overflow: "hidden",
                maxHeight: "580px",
                mt: [0, index === 0 && 10],
              },
            }}
          >
            <GatsbyImage image={image.gatsbyImageData} alt="" />
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export default DoubleImages
